var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8747 8.33332H15.6247C15.3484 8.33332 15.0835 8.44307 14.8881 8.63842C14.6928 8.83377 14.583 9.09872 14.583 9.37499V12.5H12.4997V5.20832C12.4997 4.93206 12.3899 4.6671 12.1946 4.47175C11.9992 4.2764 11.7343 4.16666 11.458 4.16666H3.12467C2.84841 4.16666 2.58346 4.2764 2.3881 4.47175C2.19275 4.6671 2.08301 4.93206 2.08301 5.20832V21.875C2.08301 22.1513 2.19275 22.4162 2.3881 22.6116C2.58346 22.8069 2.84841 22.9167 3.12467 22.9167H21.8747C22.1509 22.9167 22.4159 22.8069 22.6112 22.6116C22.8066 22.4162 22.9163 22.1513 22.9163 21.875V9.37499C22.9163 9.09872 22.8066 8.83377 22.6112 8.63842C22.4159 8.44307 22.1509 8.33332 21.8747 8.33332ZM8.33301 7.29166H10.4163V9.37499H8.33301V7.29166ZM6.24967 17.7083H4.16634V15.625H6.24967V17.7083ZM6.24967 13.5417H4.16634V11.4583H6.24967V13.5417ZM6.24967 9.37499H4.16634V7.29166H6.24967V9.37499ZM10.4163 17.7083H8.33301V15.625H10.4163V17.7083ZM10.4163 13.5417H8.33301V11.4583H10.4163V13.5417ZM19.7913 17.7083H17.708V15.625H19.7913V17.7083ZM19.7913 13.5417H17.708V11.4583H19.7913V13.5417Z",
    fill: "#38AEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCustomer);
export default __webpack_public_path__ + "static/media/add_customer.01316f2383630fa295104a24bcb9cba2.svg";
export { ForwardRef as ReactComponent };